  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

function initMegaMenuClicks() {
  var menuItems = document.querySelectorAll('.tr-flex-item > a');
  var menuParent = document.querySelector('.tr-nav-flex');

  menuItems.forEach(function (item) {
    if (item._hasMegaClick) return;
    item._hasMegaClick = true;

    item.addEventListener('click', function (e) {
      var megaMenu = this.parentElement.querySelector('.tr-mega-menu');

      if (megaMenu) {
        e.preventDefault();

        var isOpen = megaMenu.classList.contains('active');

        // Close all other mega menus
        document.querySelectorAll('.tr-mega-menu').forEach(function (menu) {
          menu.classList.remove('active');
          menu.style.opacity = '0';
          menu.style.visibility = 'hidden';
          menu.style.pointerEvents = 'none';
        });

        menuParent?.classList.remove('menu-open');

        // If it was closed before -> open it
        if (!isOpen) {
          megaMenu.classList.add('active');
          megaMenu.style.opacity = '1';
          megaMenu.style.visibility = 'visible';
          megaMenu.style.pointerEvents = 'auto';
          menuParent?.classList.add('menu-open');
        }
      }
    });
  });

  if (!window._megaMenuGlobalClickBound) {
    window._megaMenuGlobalClickBound = true;
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.tr-flex-item')) {
        document.querySelectorAll('.tr-mega-menu').forEach(function (menu) {
          menu.classList.remove('active');
          menu.style.opacity = '0';
          menu.style.visibility = 'hidden';
          menu.style.pointerEvents = 'none';
        });
        document.querySelector('.tr-nav-flex')?.classList.remove('menu-open');
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegaMenuClicks);
} else {
  initMegaMenuClicks();
}

function initHeroSlider() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initHeroSlider, 50);
    return;
  }
  const heroEl = document.querySelector('.hero-slider');
  if (heroEl && !heroEl.swiper) {
    let heroSlidesLoaded = false;
    const loadDeferredHeroSlides = () => {
      if (heroSlidesLoaded) return;
      heroSlidesLoaded = true;

      heroEl.querySelectorAll('.hero-deferred-picture').forEach(picture => {
        picture.querySelectorAll('source[data-srcset]').forEach(source => {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        });
        const img = picture.querySelector('img[data-src], img[data-srcset]');
        if (img) {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.src) img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        }
      });
    };

    new Swiper(heroEl, {
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.hero-slider .swiper-pagination',
        clickable: true
      },
      on: {
        slideChangeTransitionStart: function() {
          loadDeferredHeroSlides();
        },
        touchStart: function() {
          loadDeferredHeroSlides();
        }
      }
    });

    ['mouseenter', 'touchstart'].forEach(evt => {
      heroEl.addEventListener(evt, loadDeferredHeroSlides, { once: true, passive: true });
    });
  }
}
function scheduleHeroSliderInit() {
  let initialized = false;
  const runInit = () => {
    if (initialized) return;
    initialized = true;
    initHeroSlider();
  };

  // Allow browser to complete LCP image paint without layout thrashing
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => runInit(), { timeout: 1000 });
  } else {
    setTimeout(runInit, 600);
  }

  // Also initialize on early user touch or interaction
  ['touchstart', 'mouseenter', 'scroll'].forEach(evt => {
    window.addEventListener(evt, runInit, { once: true, passive: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleHeroSliderInit);
} else {
  scheduleHeroSliderInit();
}

class CustomProductGridSliderMain extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver((entries, obs) => {
        if (entries[0].isIntersecting) {
          obs.disconnect();
          this._observer = null;
          this.init();
        }
      }, { rootMargin: '300px' });
      this._observer.observe(this);
    } else {
      this.init();
    }
  }

  init() {
    const carousel = this.querySelector('.custom-product-grid-slider');
    if (!carousel) return;

    this.initSwiper(carousel);
    this.initArrows();
  }

  initSwiper(carousel) {
    if (this.swiper) {
      this.swiper.update();
      return;
    }

    const mobileSlides = parseInt(this.dataset.mobileSlide) || 2;
    const tabletSlides = parseInt(this.dataset.tabletSlide) || 3;
    const desktopSlides = parseInt(this.dataset.desktopSlide) || 5;

    this.swiper = new Swiper(carousel, {
      slidesPerView: 2,        // Mobile
      spaceBetween: 16,
      loop: false,
      watchOverflow: true,
      direction: 'horizontal',
      breakpoints: {
        640: {
          slidesPerView: mobileSlides
        },
        750: {
          slidesPerView: tabletSlides
        },
        1024: {
          slidesPerView: desktopSlides
        }
      },
      on: {
        slideChange: () => this.updateArrowState(),
        afterInit: () => this.updateArrowState()
      }
    });
  }

  initArrows() {
    this.prevDesk = this.querySelector('.custom-slider-btn-prev-desk');
    this.nextDesk = this.querySelector('.custom-slider-btn-next-desk');
    this.prevMobile = this.querySelector('.custom-slider-btn-prev-mobile');
    this.nextMobile = this.querySelector('.custom-slider-btn-next-mobile');
    [
      this.prevDesk,
      this.prevMobile
    ].forEach(btn => {
      btn?.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slidePrev();
      });
    });
    [
      this.nextDesk,
      this.nextMobile
    ].forEach(btn => {
      btn?.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slideNext();
      });
    });
  }

  updateArrowState() {
    if (!this.swiper) return;

    const isAtStart = this.swiper.isBeginning;
    const isAtEnd = this.swiper.isEnd;

    this.prevDesk?.classList.toggle('disabled', isAtStart);
    this.prevMobile?.classList.toggle('disabled', isAtStart);
    this.nextDesk?.classList.toggle('disabled', isAtEnd);
    this.nextMobile?.classList.toggle('disabled', isAtEnd);
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

customElements.define("custom-product-grid-slider-main", CustomProductGridSliderMain);

class CustomSwatches extends HTMLElement {
  constructor() {
    super();
    this.onInputChange = this.onInputChange.bind(this);
  }

  connectedCallback() {
    this.radios = this.querySelectorAll('input[type="radio"][data-variant-id]');
    this.radios.forEach(radio => {
      radio.addEventListener("change", this.onInputChange);
    });

    const anyRadio = this.radios[0];
    if (!anyRadio) return;

    const productId = anyRadio.getAttribute("data-product-id");
    const sectionId = anyRadio.getAttribute("data-section-id");

    const savedVariantId =
      sessionStorage.getItem(`selectedVariant-${sectionId}-${productId}`) ||
      sessionStorage.getItem(`selectedSwatch-${sectionId}-${productId}`);

    let radioToActivate = null;

    // 1️⃣ sessionStorage wins
    if (savedVariantId) {
      radioToActivate = this.querySelector(
        `input[type="radio"][data-variant-id="${savedVariantId}"]`
      );
    }

    // 2️⃣ already-checked radio in DOM
    if (!radioToActivate) {
      radioToActivate = this.querySelector(
        'input[type="radio"][data-variant-id]:checked'
      );
    }

    // 3️⃣ fallback to first radio
    if (!radioToActivate) {
      radioToActivate = this.radios[0];
      radioToActivate.checked = true;
    }

    // 🔥 ALWAYS run logic on load
    if (radioToActivate) {
      this.onInputChange({ target: radioToActivate, isInitial: true });
    }
  }


  loadVariantData(productId, variantId) {
    const scriptTag = document.querySelector(`script[data-product-id='${productId}']`);

    if (!scriptTag) {
      console.warn(`Script tag for product ${productId} not found.`);
      return null;
    }

    const scriptContent = scriptTag.textContent;

    // Match: var variantDataMap = { ... };
    const match = scriptContent.match(/var\s+variantDataMap\s*=\s*(\{[\s\S]*?\});/);

    if (!match || !match[1]) {
      console.warn(`Could not parse variantDataMap for product ${productId}`);
      return null;
    }
    let variantMap;
    try {
      variantMap = JSON.parse(match[1]);
    } catch (err) {
      console.error(`JSON parse error for product ${productId}:`, err);
      return null;
    }

    return variantMap[variantId] || null;
  }

  getProductMediaArray(productId) {
    const script = document.querySelector(`script[data-product-id='${productId}']`);
    if (!script) return [];

    const scriptContent = script.textContent;

    const match = scriptContent.match(/var\s+productMedia\s*=\s*(\[[^\]]+\])/);
    if (!match) return [];

    try {
      const mediaArray = JSON.parse(match[1].replace(/(['"])?https?:/g, '')); // normalize protocol
      return mediaArray;
    } catch (e) {
      console.warn('Could not parse productMedia for product:', productId, e);
      return [];
    }
  }

  storeSelectedVariant(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedVariant-' + sectionId + '-' + productId, variantId);
  }

  storeSelectedSwatch(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedSwatch-' + sectionId + '-' + productId, variantId);
  }

  triggerDefaultVariant() {
    const firstChecked =
      this.querySelector('input[type="radio"][data-variant-id]:checked') ||
      this.querySelector('input[type="radio"][data-variant-id]');
    
    if (firstChecked) {
      this.onInputChange({ target: firstChecked, isInitial: true });
    }
  }


  onInputChange(event) {
    const radio = event.target;

    const newVariantId = radio.getAttribute("data-variant-id");
    const newProductId = radio.getAttribute("data-product-id");
    const sectionId = radio.getAttribute("data-section-id");

    this.storeSelectedVariant(sectionId, newProductId, newVariantId);
    this.storeSelectedSwatch(sectionId, newProductId, newVariantId);

    const getVariantData = this.loadVariantData(newProductId, newVariantId);

    const productGrid = radio.closest("[card-product-grid]");

    const sliderElement = productGrid.querySelector('[card-product-slider]');

    const selectedColor = radio.value;
    if (sliderElement && selectedColor) {
      const allSlides = sliderElement.querySelectorAll('.swiper-slide-main');

      allSlides.forEach(slide => {
        const slideColor = slide.getAttribute('data-color');
        if (slideColor == selectedColor) {
          slide.style.display = '';
          slide.classList.remove('non-swiper-slide');
          slide.classList.add('swiper-slide');
          if (!event || !event.isInitial) {
            const img = slide.querySelector('img[data-src]');
            if (img) {
              if (img.dataset.srcset) img.srcset = img.dataset.srcset;
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              img.removeAttribute('data-srcset');
            }
          }
        } else {
          slide.style.display = 'none';
          slide.classList.add('non-swiper-slide');
          slide.classList.remove('swiper-slide');
        }
      });

      // Count visible slides
      const visibleSlides = sliderElement.querySelectorAll('.swiper-slide').length;

      const cardSlider = sliderElement.closest('card-product-slider');

      if (cardSlider && typeof cardSlider.rebuild === 'function') {
        cardSlider.rebuild();
      }

    }


    // varinatId-replace-------------

    const productForm = productGrid.querySelector('product-form');
    if (productForm) {
      const idElement = productForm.querySelector("[name='id']")
      if (idElement) {
        idElement.value = newVariantId;
      }
    }

    // 🔁 Re-run active filter view after swatch change
    const filterView = document.querySelector("filter-view");

    if (filterView && typeof filterView.runActiveView === "function") {
      filterView.runActiveView();
    }

  }
}
customElements.define("custom-swatches", CustomSwatches);

class CardProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.slider = null;
    this.parentCollection = null;
  }

  connectedCallback() {
    if (this.swiper) return;

    this.slider = this.querySelector('.swiper');
    if (!this.slider) return;

    this.parentCollection = this.closest('custom-collection');

    // Ensure all variant images load immediately upon scrolling into view and dots are initialized
    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver((entries, obs) => {
        if (entries[0].isIntersecting) {
          obs.disconnect();
          this._observer = null;
          this.loadCardImages();
          if (!this.swiper) {
            this.init();
          }
        }
      }, { rootMargin: '200px 0px' });
      this._observer.observe(this);
    } else {
      this.loadCardImages();
      if (!this.swiper) {
        this.init();
      }
    }

    const triggerOnTouch = () => {
      this.loadCardImages();
      if (!this.swiper) {
        this.init();
      }
    };
    this.addEventListener('mouseenter', triggerOnTouch, { once: true, passive: true });
    this.addEventListener('touchstart', triggerOnTouch, { once: true, passive: true });
  }

  loadCardImages() {
    this.querySelectorAll('img[data-src]').forEach(img => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.classList.add('is-loaded');
    });
    const card = this.closest('[card-product-grid], .card-wrapper, .swiper-slide') || this;
    card.querySelectorAll('.collection-product-card__swatch:not(.swatch-hidden) label[data-swatch-image]').forEach(lbl => {
      lbl.style.backgroundImage = "url('" + lbl.getAttribute('data-swatch-image') + "')";
      lbl.removeAttribute('data-swatch-image');
    });
  }

  init() {
    this.destroy();
    this.initSwiper();
    this.initArrows();
    this.onChange();
  }

  updatePaginationGroups() {
    const bullets = this.querySelectorAll('.swiper-pagination-bullet');
    if (!bullets.length) return;

    const groupSize = 3;
    const swiper = this.swiper;
    const activeIndex = swiper.realIndex;

    const groupStart = Math.floor(activeIndex / groupSize) * groupSize;
    const groupEnd = groupStart + groupSize;

    bullets.forEach((bullet, index) => {
      bullet.style.display =
        index >= groupStart && index < groupEnd ? 'inline-block' : 'none';
    });
  }


  applyFilter(color) {
    const slides = this.querySelectorAll('.swiper-slide-main');

    slides.forEach(slide => {
      slide.classList.toggle(
        'swiper-slide',
        slide.dataset.color === color
      );

      slide.style.display =
        slide.dataset.color === color ? '' : 'none';
    });
  }


  loadActiveImage() {
    if (!this.swiper || !this.swiper.slides) return;
    const currentSlide = this.swiper.slides[this.swiper.activeIndex];
    if (currentSlide) {
      let activeimage = currentSlide.querySelector('img');
      if (activeimage) {
        if (activeimage.dataset.srcset) {
          activeimage.srcset = activeimage.dataset.srcset;
          activeimage.removeAttribute('data-srcset');
        }
        const dataSrc = activeimage.dataset.src;
        if (dataSrc && activeimage.getAttribute('src') !== dataSrc) {
          activeimage.src = dataSrc;
          activeimage.removeAttribute('data-src');
        }
        activeimage.classList.add('is-loaded');
      }
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      loop: true,
      nested: true,
      direction: 'horizontal',
      observer: true,
      observeParents: true,
      touchStartPreventDefault: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });

    this.updatePaginationGroups();
    this.loadActiveImage();
  }

  onChange() {
    this.swiper.on('slideChange', () => {
      this.updatePaginationGroups();
      this.loadActiveImage();
    });
  }

  initArrows() {
    const prevBtn = this.querySelector('[prev]');
    const nextBtn = this.querySelector('[next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slidePrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slideNext();
      });
    }
  }

  rebuild() {
    this.init();
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    this.destroy();
  }
}

customElements.define('card-product-slider', CardProductSlider);


class AccordionWrapper extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.accordion-item');
  }

  connectedCallback() {
    this.items.forEach(item => {
      const question = item.querySelector('.accordion-question');

      question.addEventListener('click', () => {
        this.toggleItem(item);
      });
    });
  }

  toggleItem(activeItem) {
    this.items.forEach(item => {
      const answer = item.querySelector('.accordion-answer');

      if (item === activeItem) {
        if (item.classList.contains('active')) {
          // Close
          answer.style.maxHeight = null;
          item.classList.remove('active');
        } else {
          // Open
          answer.style.maxHeight = answer.scrollHeight + 'px';
          item.classList.add('active');
        }
      } else {
        // Close others
        item.classList.remove('active');
        answer.style.maxHeight = null;
      }
    });
  }
}
customElements.define('accordion-wrapper', AccordionWrapper);

window.initProductSlider = () => {
  document.querySelectorAll("card-product-slider").forEach(el => el.initSlider?.());
};

function dropdownProducts() {
  const wrapper = document.querySelector('.dropdown-wrapper');
  if (!wrapper) return console.warn('Dropdown wrapper not found');
  const button = wrapper.querySelector('.dropdown-button'), menu = wrapper.querySelector('#dropdownMenu');
  button.addEventListener('click', () => wrapper.classList.toggle('show'));
  document.addEventListener('click', e => { if (!wrapper.contains(e.target)) wrapper.classList.remove('show'); });
  menu.querySelectorAll('.dropdown-item').forEach(item => item.addEventListener('click', () => wrapper.classList.remove('show')));
}
dropdownProducts();


function initAnnouncementSwiper() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initAnnouncementSwiper, 50);
    return;
  }
  document.querySelectorAll('.announcement-bar.swiper').forEach((slider) => {
    if (slider.swiper) return;
    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const speed = Number(slider.dataset.speed) * 1000 || 5000;

    new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      speed: 600,
      autoplay: autoplayEnabled
        ? {
            delay: speed,
            disableOnInteraction: false,
          }
        : false,
      navigation: {
        nextEl: slider.querySelector('.slider-button--next'),
        prevEl: slider.querySelector('.slider-button--prev'),
      },
      a11y: {
        enabled: true,
      },
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnnouncementSwiper);
} else {
  initAnnouncementSwiper();
}


  document.addEventListener("DOMContentLoaded", () => {
    const headings = document.querySelectorAll(
      ".footer-block--menu .footer-block__heading"
    );

    const isMobile = () => window.innerWidth <= 768;

    const setupAccordion = () => {
      setTimeout(() => {
        headings.forEach(h => {
          const c = h.nextElementSibling;
          if (!c) return;

          if (isMobile()) {
            c.style.overflow = "hidden";
            c.style.maxHeight = c.classList.contains("open")
              ? c.scrollHeight + "px"
              : "0px";
          } else {
            c.style.maxHeight = "";
            c.style.overflow = "";
            c.classList.remove("open");
            h.classList.remove("active");
          }
        });
      }, 50); // adjust if needed (0–100ms is typical)
    };

    headings.forEach(h => {
      h.addEventListener("click", e => {
        if (!isMobile()) return;

        e.preventDefault();

        const c = h.nextElementSibling;
        if (!c) return;

        h.classList.toggle("active");
        c.classList.toggle("open");

        c.style.maxHeight = c.classList.contains("open")
          ? c.scrollHeight + "px"
          : "0px";
      });
    });

    setupAccordion();
    window.addEventListener("resize", setupAccordion);
  });

  // Deferred Swatch Image Activation on interaction or +more click
  (function() {
    function activateSwatches(container) {
      if (!container) return;
      container.querySelectorAll('label[data-swatch-image]').forEach(function(lbl) {
        lbl.style.backgroundImage = "url('" + lbl.getAttribute('data-swatch-image') + "')";
        lbl.removeAttribute('data-swatch-image');
      });
    }

    document.addEventListener('click', function(e) {
      var more = e.target.closest('.swatch-more');
      if (more) {
        var parent = more.closest('.card-swatch--standard, custom-swatches') || more.parentElement;
        if (parent) {
          parent.querySelectorAll('.swatch-hidden').forEach(function(el) {
            el.classList.remove('swatch-hidden');
            var lbl = el.querySelector('label[data-swatch-image]');
            if (lbl) {
              lbl.style.backgroundImage = "url('" + lbl.getAttribute('data-swatch-image') + "')";
              lbl.removeAttribute('data-swatch-image');
            }
          });
          more.style.display = 'none';
        }
      }
    });

    ['mouseenter', 'touchstart', 'focusin'].forEach(function(evt) {
      document.addEventListener(evt, function(e) {
        var card = e.target && e.target.closest && e.target.closest('[card-product-grid], .card-wrapper, custom-swatches');
        if (card) {
          activateSwatches(card);
        }
      }, { capture: true, passive: true });
    });
  })();